// client/src/utils/api.js
// Returns the API base URL, INCLUDING the "/api" suffix.
// Callers append paths like "/auth/session" or "/scoring/semantic".
const getApiBaseUrl = () => {
  const envUrl = (process.env.REACT_APP_API_URL || "")
    .trim()
    .replace(/\/+$/, "")       // strip trailing slashes
    .replace(/\/api$/, "");    // avoid "/api/api" if .env already has /api

  if (typeof window !== "undefined") {
    const { hostname, protocol } = window.location;

    // Production: same-origin behind the reverse proxy
    if (hostname === "testx.cc" || hostname === "www.testx.cc") {
      return "/api";
    }

    // Local dev: follow the page's own hostname so the auth cookie
    // (host-scoped, SameSite=lax) is always sent.
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return `${protocol}//${hostname}:5008/api`;
    }

    // Any other host (staging): explicit override, else same-origin
    return envUrl ? `${envUrl}/api` : "/api";
  }

  return envUrl ? `${envUrl}/api` : "http://localhost:5008/api";
};

export default getApiBaseUrl;